import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { ApiService } from '@app/common/services/api.service';
import { ContactFormData } from '@app/types/contact-form.types';

@Injectable({
  providedIn: 'root'
})
export class ContactFormApiService {
  private apiService = inject(ApiService);

  sendMessage(data: ContactFormData): Observable<void> {
    return this.apiService.mpPost('/contact-message', data);
  }
}
